/** Convert HTML fragments from official sources into readable plain text (no DOM). */
const NAMED_ENTITIES: Record<string, string> = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " ",
};

function decodeHtmlEntities(value: string): string {
  return value
    .replace(/&#x([0-9a-fA-F]+);/gu, (_, hex: string) => {
      const code = Number.parseInt(hex, 16);
      return Number.isSafeInteger(code) ? String.fromCodePoint(code) : "";
    })
    .replace(/&#(\d+);/gu, (_, dec: string) => {
      const code = Number(dec);
      return Number.isSafeInteger(code) ? String.fromCodePoint(code) : "";
    })
    .replace(/&([a-zA-Z]+);/gu, (match, name: string) => NAMED_ENTITIES[name.toLowerCase()] ?? match);
}

export function htmlToPlainText(value: string): string {
  if (!value) return "";
  const withBreaks = value
    .replace(/<\s*br\s*\/?\s*>/giu, "\n")
    .replace(/<\/\s*(?:p|div|li|tr|h[1-6])\s*>/giu, "\n")
    .replace(/<\s*(?:p|div|li|tr|h[1-6])\b[^>]*>/giu, "\n");
  const withoutTags = withBreaks.replace(/<[^>]+>/gu, "");
  return decodeHtmlEntities(withoutTags)
    .replace(/\u00a0/gu, " ")
    .replace(/[ \t]+\n/gu, "\n")
    .replace(/\n[ \t]+/gu, "\n")
    .replace(/\n{3,}/gu, "\n\n")
    .replace(/[ \t]{2,}/gu, " ")
    .trim();
}
